document.addEventListener('DOMContentLoaded', function() {
  const container = document.querySelector('.custom-recipe-details-left-content');
  const listItems = container.querySelectorAll('li');
  
  listItems.forEach(function(li) {
    const img = li.querySelector('img');
    if (img) {
      // Remove image from li
      li.removeChild(img);
      
      // Create a wrapper div for better styling control
      const imgContainer = document.createElement('div');
      imgContainer.className = 'recipe-image-container';
      imgContainer.appendChild(img);
      
      // Insert after the li
      li.insertAdjacentElement('afterend', imgContainer);
      
      // Optional: Add a class to the original li to mark it
      li.classList.add('has-extracted-image');
    }
  });
  
});
// (function() {
//   var links = document.links;
//   for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
//     if (links[i].hostname !== window.location.hostname) {
//       links[i].target = '_blank';
//       links[i].rel = 'noreferrer noopener';
//     }
//   }
// })();
////////////////////////////////////  Measura app
(function () {
  const TARGET_PARAM = 'selling_plan';
  const HIDE_CLASS = 'custom-hide';
  const POS_SELECTOR = '.atomic-pos-field';
  const QTY_SELECTOR = '.custom-quantity-selector';

  function applyVisibility() {
    const params = new URLSearchParams(window.location.search);
    const hasSellingPlan = params.has(TARGET_PARAM) && params.get(TARGET_PARAM) !== '';

    // Hide .atomic-pos-field when selling_plan is present
    document.querySelectorAll(POS_SELECTOR).forEach(el => {
      el.classList.toggle(HIDE_CLASS, hasSellingPlan);
    });

    // Show .custom-quantity-selector when selling_plan is present (opposite of above)
    document.querySelectorAll(QTY_SELECTOR).forEach(el => {
      el.classList.toggle(HIDE_CLASS, !hasSellingPlan);
    });
  }

  // Patch pushState / replaceState to detect Shopify's variant URL updates
  ['pushState', 'replaceState'].forEach(method => {
    const original = history[method];
    history[method] = function () {
      const result = original.apply(this, arguments);
      window.dispatchEvent(new Event('locationchange'));
      return result;
    };
  });

  // Back/forward navigation
  window.addEventListener('popstate', () => window.dispatchEvent(new Event('locationchange')));

  // Unified URL-change hook
  window.addEventListener('locationchange', applyVisibility);

  // Re-run when the DOM mutates (variant swaps re-render the PDP block, wiping classes)
  const mo = new MutationObserver(() => applyVisibility());
  function startObserver() {
    mo.observe(document.body, { childList: true, subtree: true });
    applyVisibility();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startObserver);
  } else {
    startObserver();
  }
})();